import {
  getBreadcrumbsListSchema,
  validateItemsForBreadcrumbsListSchema,
} from '@domain/seo/schema';
import { JsonLd } from '../JsonLd/JsonLd';

interface IProps {
  items: {
    label: string;
    link?: string;
  }[];
}

export const BreadcrumbsSchema = ({ items }: IProps) => {
  if (validateItemsForBreadcrumbsListSchema(items)) {
    const breadcrumbsListSchema = getBreadcrumbsListSchema(items);
    return <JsonLd schema={breadcrumbsListSchema} />;
  }

  return <></>;
};
